/* eslint-disable jsx-a11y/anchor-is-valid */
export class AppointmentNotFound extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  /**
   * Construye la URL de redirección usando la URL base del sitio y la propiedad TargetURL.
   * @returns {string} URL de redirección.
   */
  getUrlRedirectOtherPage() {
    const url = _spPageContextInfo.siteAbsoluteUrl + this.props.TargetURL;
    return url;
  }

  /**
   * Inserta el nombre del usuario en el mensaje si encuentra el marcador (aquiNombre).
   * @param {string} message - Mensaje original.
   * @returns {string} Mensaje con el nombre del usuario insertado o el mensaje original.
   */
  infoUserInToMessage(message) {
    if (message !== undefined) {
      var position = message.indexOf('(aquiNombre)');
      var getMessage = message;
      var change = '(aquiNombre)';

      if (position > -1) {
        return getMessage.split(change).join(this.props.UserNameToRender);
      } else {
        return message;
      }
    }
  }

  /**
   * Cierra el panel de advertencia ajustando el estilo y agregando la clase de cerrado.
   * @param {object} e - Evento click del botón cerrar.
   */
  close(e) {
    var height = e.target.parentNode.parentNode.parentNode.offsetHeight;
    e.target.parentNode.parentNode.parentNode.style.height = height + 'px';
    e.target.parentNode.parentNode.parentNode.classList.add('closeW');
  }

  render() {
    return (
      <div id="appointmentNotFound">
        <div className="warning-blue">
          <div className="col-sm-12 col-md-1 text-center">
            <i className={this.props.NotFoundIcon}></i>
          </div>
          <div className="col-sm-12 col-md-11">
            <div className={this.props.NotFoundMessageBottom == undefined ? 'top' : 'topM'}>
              {this.infoUserInToMessage(this.props.NotFoundMessage)}
            </div>
            <div className="bottomM">
              {this.props.NotFoundMessageBottom == undefined ? '' : this.props.NotFoundMessageBottom}
            </div>
            {this.props.NoLink ? null : (
              <a
                href={this.getUrlRedirectOtherPage()}
                rel="noreferrer"
                target={this.props.TargetContent === true ? '_blank' : '_self'}
              >
                {' '}
                asignar medico personal{' '}
              </a>
            )}
          </div>
          {this.props.showBtn == undefined ? null : (
            <div className="btnCerrar">
              <i className="fa fa-times" onClick={this.close.bind(this)}></i>
              <a onClick={this.close.bind(this)}>Cerrar</a>
            </div>
          )}
        </div>
      </div>
    );
  }
}
